import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '.scroll-to-top__button';
const PLUGIN_NAME = 'ScrollToTop';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "scroll-to-top" */ './scroll-to-top'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/scroll-to-top/scroll-to-top--split.js